<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    width="850"
    scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Email"
                v-model="selectedUser.Email"
                :rules="[(v) => !!v || 'required']"
                @blur="getNames"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="6">
              <v-text-field
                label="First Name"
                v-model="selectedUser.FirstName"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                label="Last Name"
                v-model="selectedUser.LastName"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="6">
              <v-text-field
                label="Agency"
                v-model="selectedUser.Agency"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                label="Division"
                v-model="selectedUser.Division"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="6">
              <v-text-field
                return-masked-value
                v-mask="'###-###-####'"
                label="Office Phone"
                v-model="selectedUser.OfficePhone"
              ></v-text-field>
            </v-col>

            <v-col sm="6">
              <v-text-field
                return-masked-value
                v-mask="'###-###-####'"
                label="Mobile Phone"
                v-model="selectedUser.MobilePhone"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="isSuperUser">
            <v-col sm="12">
              <v-checkbox
                label="Is Active"
                v-model="selectedUser.IsActive"
              ></v-checkbox>
            </v-col>
          </v-row>
          <!-- //TemplateTODO: The multiselects will need to have the props updated to the correct values
          We are not able to determine the nested relations for the template generation
          you will also need to load the appropriate lookup component-->
          <!-- <v-row no-gutters>
            <v-col sm="12">
              <LuRelation
                v-model="selectedUser.Comment"
                selfKey="UserID"
                :selfID="selectedUser.ID"
                relatedItemKey="RelationID"
                joinItemName="Comment"
              ></LuRelation>
            </v-col>
          </v-row> -->
          <!-- <v-row no-gutters>
            <v-col sm="12">
              <LuRelation
                v-model="selectedUser.TrackedBill"
                selfKey="UserID"
                :selfID="selectedUser.ID"
                relatedItemKey="RelationID"
                joinItemName="TrackedBill"
              ></LuRelation>
            </v-col>
          </v-row> -->
          <v-row v-if="isSuperUser">
            <v-col sm="12">
              <LuRole
                v-model="selectedUser.UserRoles"
                selfKey="UserID"
                :selfID="selectedUser.ID"
                relatedItemKey="RoleID"
                joinItemName="UserRole"
              ></LuRole>
            </v-col>
          </v-row>
          <UserAgencyGrid
            :selectedUserAgencies="selectedUserAgencies"
            :selectedUserID="selectedUser.ID"
            :selectedAgencyID="selectedAgencyID"
            @newUserAgency="addUserAgency"
            @refreshUserAgencies="refreshUserAgencies"
          ></UserAgencyGrid>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="saveUserDetails" :disabled="saving" color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { mask } from 'vue-the-mask'
import LuRole from '@components/select/multi-join/LuRole'
import { get, sync, commit, call } from 'vuex-pathify'
import { authMethods, authComputed } from '@state/helpers'
import UserAgencyGrid from '@components/admin/UserAgencyGrid'

import User from '@classes/User'
export default {
  components: { LuRole, UserAgencyGrid },
  data: () => ({
    dialog: false,
    valid: true,
    selectedUser: new User(),
    modalText: '',
  }),
  directives: {
    mask,
  },
  props: {
    selectedAgencyID: {
      type: Number,
    },
  },
  created() {},
  computed: {
    ...authComputed,
    ...get('user', ['saving']),
    selectedUserAgencies() {
      if (this.isSuperUser) {
        return this.selectedUser.UserAgencies
      } else {
        return this.selectedUser.UserAgencies.filter(
          (ua) => ua.AgencyID == this.selectedAgencyID
        )
      }
    },
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('user', ['saveUser']),
    ...call('userAgency', ['loadUserAgenciesForUser']),
    async validate() {
      this.$refs.form.validate()
    },
    editUser(entry) {
      this.selectedUser = new User(entry)
      this.modalText = 'Edit User'
      this.dialog = !this.dialog
    },
    addUser() {
      this.modalText = 'Insert User'
      this.selectedUser = new User()
      this.dialog = !this.dialog
    },
    saveUserDetails() {
      this.validate().then(() => {
        if (this.valid) {
          var userToSave = this.selectedUser.removeRelated()
          if (!this.isSuperUser) {
            userToSave.UserRoles = null
          }
          if (userToSave.ID > 0) {
            userToSave.UserAgencies = null
          }
          this.saveUser(userToSave).then(
            (res) => {
              this.$emit('refresh')
              this.selectedUser = new User()
              this.$refs.form.resetValidation()
            },
            (err) => {}
          )
          this.dialog = false
        }
      })
    },
    cancelEntry() {
      this.dialog = false
      this.selectedUser = new User()
      this.$refs.form.resetValidation()
    },
    getNames() {
      if (
        this.selectedUser.Email &&
        this.selectedUser.Email.endsWith('@wyo.gov')
      ) {
        let email = this.selectedUser.Email.replace('@wyo.gov', '')
        let names = email.split('.')
        if (names.length == 2) {
          if (!this.selectedUser.FirstName) {
            let name = names[0].replace(/[0-9]/gi, '')
            this.selectedUser.FirstName =
              name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
          }
        }
        if (!this.selectedUser.LastName) {
          let name = names[1].replace(/[0-9]/gi, '')
          this.selectedUser.LastName =
            name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
        }
      }
    },
    addUserAgency(ua) {
      this.selectedUser.UserAgencies.push(ua)
    },
    refreshUserAgencies() {
      this.loadUserAgenciesForUser(this.selectedUser.ID).then((res) => {
        this.selectedUser.UserAgencies = res.data
      })
    },
  },
}
</script>
<style></style>
